import React from 'react';
import { H2, P, OL, UL, LI, FeatureLink, Callout } from './_shared';

export default {
  slug: 'adding-clients',
  title: 'Adding clients & importing leads',
  category: 'leads-deals',
  summary: 'Three ways to get contacts into RealtyFlows: manually, via CSV, or automatically from your lead source.',
  searchTerms: ['client', 'lead', 'import', 'csv', 'contact', 'new'],
  related: ['managing-pipeline', 'integrations-overview'],
  Body: () => (
    <>
      <H2>Three ways to add clients</H2>
      <OL>
        <LI>
          <strong>Manually.</strong>{' '}
          <FeatureLink to="/clients">Clients → New Client</FeatureLink>. Name
          and email are the only required fields; everything else can be
          filled in over time and the AI scoring will adapt.
        </LI>
        <LI>
          <strong>CSV import.</strong> Settings → Import. Upload a CSV with at
          least a name or email column and we'll map the rest. Duplicates are
          detected by email — existing clients are updated in place rather
          than duplicated.
        </LI>
        <LI>
          <strong>Lead sources.</strong>{' '}
          <FeatureLink to="/settings/integrations">Integrations Hub</FeatureLink>{' '}
          connects to your Zillow, Realtor.com, Facebook Lead Ads, or website
          contact form. New leads land in your pipeline automatically.
        </LI>
      </OL>

      <H2>What gets stored automatically</H2>
      <P>
        Every interaction is logged against the client record — emails,
        appointments, signed docs, stage changes, AI suggestions. That feed
        is the source of truth for the <FeatureLink to="/help/health-score">
        AI engagement score</FeatureLink> and the <FeatureLink to="/help/broker-dashboard">
        broker dashboard</FeatureLink>.
      </P>

      <H2>Tagging & segmentation</H2>
      <P>
        Each client carries a <strong>status</strong> (pipeline stage),
        <strong> source</strong> (where they came from), and <strong>intent
        </strong> (low/medium/high). Filter the client list by any combo. The
        intent field is set by the AI based on activity, but you can override
        it.
      </P>

      <Callout kind="warn">
        Imported a list and seeing weird names? Double-check the CSV
        encoding — RealtyFlows expects UTF-8. Save your spreadsheet as
        "CSV UTF-8" before uploading.
      </Callout>
    </>
  ),
};
